var React = require('react');

function Copy (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M21 0H9.33333C8.0465 0 7 1.0465 7 2.33333V7H2.33333C1.0465 7 0 8.0465 0 9.33333V21C0 22.2868 1.0465 23.3333 2.33333 23.3333H14C15.2868 23.3333 16.3333 22.2868 16.3333 21V16.3333H21C22.2868 16.3333 23.3333 15.2868 23.3333 14V2.33333C23.3333 1.0465 22.2868 0 21 0ZM2.33333 21V9.33333H14L14.0023 21H2.33333ZM21 14H16.3333V9.33333C16.3333 8.0465 15.2868 7 14 7H9.33333V2.33333H21V14Z"}));
}

Copy.defaultProps = {"width":"23","height":"24","viewBox":"0 0 23 24","fill":"none"};

module.exports = Copy;

Copy.default = Copy;
